import ItemReport from "../Components/ItemDetailReport";
import StockReport from "../Components/StockReport";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ProductWiseSales from "../Components/ProductWiseSales";
import AllInvoiceReport from "../Components/AllInvoiceReport";
import AllSalesReport from "../Components/AllSalesReport";
import ProfitVsRevenueReport from "../Components/ProfitVsRevenueReport";
import CustomerVehicleReport from "../Components/CustomerVehicleReport";
import TechnicianBillingReport from "../Components/TechnicianBillingReport";
import LabourSalesReport from "../Components/LabourSalesReport";

export const ReportModules = [
    {
        id: 0,
        name: 'Profit vs Revenue',
        component: ProfitVsRevenueReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 1,
        name: 'All Sales Report',
        component: AllSalesReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 2,
        name: 'Sales Report',
        component: ItemReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 3,
        name: 'All Invoices Report',
        component: AllInvoiceReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 4,
        name: 'Inventory Report',
        component: StockReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 5,
        name: 'Product Wise Sales Report',
        component: ProductWiseSales,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 6,
        name: 'Customer & Vehicle Report',
        component: CustomerVehicleReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 7,
        name: 'Technician Billing Report',
        component: TechnicianBillingReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 8,
        name: 'Labour Sales Report',
        component: LabourSalesReport,
        icon: <ArticleOutlinedIcon />
    }
];
